var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Favorites"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1611,
    transform: "translate(-487 -260)",
    fill: "#FCFBFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SECTION - michael's favorites"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SECTION - search michael's favs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON - search bar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: -16,
    y: -12,
    width: 499,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ICON - search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7074 14.297L12.6107 11.1989C14.9278 8.10241 14.296 3.71375 11.1995 1.3966C8.10296 -0.920545 3.71429 -0.288735 1.39714 2.80778C-0.920003 5.9043 -0.288193 10.293 2.80832 12.6101C5.2957 14.4714 8.71206 14.4714 11.1995 12.6101L14.2975 15.7082C14.6869 16.0975 15.3181 16.0975 15.7074 15.7082C16.0967 15.3189 16.0967 14.6876 15.7074 14.2983L15.7074 14.297ZM7.02972 12.0122C4.27768 12.0122 2.04674 9.78121 2.04674 7.02917C2.04674 4.27714 4.27768 2.0462 7.02972 2.0462C9.78175 2.0462 12.0127 4.27714 12.0127 7.02917C12.0098 9.77996 9.78054 12.0092 7.02972 12.0122Z",
    fill: "black",
    fillOpacity: 0.5
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.849a82eaa9a029461b728d5f7387e5ea.svg";
export { ForwardRef as ReactComponent };